module.exports = __webpack_public_path__ + "static/img/video_icon1_1.b298cc0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/broadcast/video_icon1_1.png
// module id = /h2a
// module chunks = 0